import { getBaseUrl } from '../config/appSettings';
import { performLogout } from '../utils/logout';

function extractNotifications(data) {
  const code = data?.response?.responseCode ?? data?.responseCode;
  if (code !== undefined && code !== 0) return [];
  const result = data?.result ?? data?.Result ?? data;
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.Data)) return result.Data;
  return [];
}

/**
 * Fetch active Partner system notifications for the current screen.
 * Audience is filtered server-side (Partner only).
 */
export async function fetchActiveSystemNotifications({ token, screenPath, onTokenExpired }) {
  const baseUrl = getBaseUrl();
  if (!baseUrl || !token) {
    return { ok: false, notifications: [], error: '' };
  }

  const path = encodeURIComponent(screenPath || '/');
  const url = `${baseUrl}/Generic/GetActiveSystemNotifications?screenPath=${path}`;

  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401) {
      onTokenExpired?.();
      return { ok: false, notifications: [], error: '' };
    }

    let data = null;
    try {
      data = await res.json();
    } catch {
      data = null;
    }

    if (!res.ok) {
      return {
        ok: false,
        notifications: [],
        error:
          data?.response?.responseMessage ??
          data?.message ??
          data?.responseMessage ??
          'Failed to load system notifications.',
      };
    }

    const rows = extractNotifications(data).map((item) => ({
      id: item.systemNotificationId ?? item.SystemNotificationId,
      messageText: item.messageText ?? item.MessageText ?? '',
      showOnAllScreens: Boolean(item.showOnAllScreens ?? item.ShowOnAllScreens),
      targetScreens: item.targetScreens ?? item.TargetScreens ?? [],
    }));

    return { ok: true, notifications: rows.filter((n) => n.messageText), error: '' };
  } catch {
    return { ok: false, notifications: [], error: 'Failed to load system notifications.' };
  }
}

/** Default 401 handler for Partner portal (clears session + redirects via loginStateChanged). */
export function handleSystemNotificationTokenExpired(clearUserData) {
  performLogout(clearUserData);
}
